import { apiPatch } from '@/api/api.ts'

export interface IReqPatchBioAlertAssignPerson {
    manager_name: string;
}

export const apiPatchBioAlertAssignPerson = async (id: number, params: IReqPatchBioAlertAssignPerson) => {
    return await apiPatch<undefined>(`/alert/bio/${id}`, {
        type: '담당자 배정',
        manager_name: params.manager_name
    })
}

export interface IReqPatchBioAlertProcess {
    task_content: string;
    task_result: string;
}

export const apiPatchBioAlertProcess = async (id: number, params: IReqPatchBioAlertProcess) => {
    return await apiPatch<undefined>(`/alert/bio/${id}`, {
        type: '확인 완료',
        task_result: params.task_result,
        task_content: params.task_content
    })
}

